(function ($) {
    var screen_page_content_scrollspy = function () {
        $('[scrollspy]').each(function () {
            var elem = $(this);
            var target_markup = elem.attr('scrollspy');
            var target = $(target_markup);
            var menu_markup = elem.attr('scrollspy-menu');
            var menu = $(menu_markup);
            var screen = $(target.attr('data-screen-target'));
            target.on('scrollSpy:enter', function () {
                menu.addClass("active");
                screen.addClass("active");
                //target.removeClass("inactive").addClass("active");
            });
            target.on('scrollSpy:exit', function () {
                menu.removeClass("active");
                screen.removeClass("active");
                //target.addClass("inactive").removeClass("active");
            });
            //target.addClass("inactive");
            target.scrollSpy();
        });
    };
    $(screen_page_content_scrollspy);

    var blur_background = function () {
        var scroll_top = $(this).scrollTop();
        var doc_height = $(document).height() + 1000;
        var nav_height = $('nav').height();
        var window_height = $(this).height();
        var window_width = $(this).width();
        var page_menu_offset = $(".page-menu").offset();
        var page_menu_outter_width = $(".page-menu").outerWidth();
        var $admin_bar = $('#wpadminbar');

        //if ($admin_bar.length > 0) {
        //    scroll_top += $admin_bar.height();
        //}
        $(".content").css('top', nav_height + $admin_bar.height());

        $('.screen-page-menu-blur').each(function () {
            var elem = $(this);
            elem.css("clip",
                "rect(" +
                (nav_height - 10) + "px," +
                (page_menu_offset.left + page_menu_outter_width - 1) + "px," +
                (scroll_top + window_height) + "px," +
                page_menu_offset.left + "px)");
        });        

        $('.screen-nav-blur').each(function () {
            var elem = $(this);
            var height = nav_height;
            if ($admin_bar.length > 0) {
                height += $admin_bar.height();
            }
            elem.css("clip", "rect(" + 0 + "px," + window_width + "px," + (height) + "px,0)");
        });

        $('.page-content-nav-blur').each(function () {
            var elem = $(this);
            var offectTop = nav_height + scroll_top;
            if ($admin_bar.length > 0) {
                offectTop -= nav_height;
            }
            elem.css("clip", "rect(" + 0 + "px," + window_width + "px," + (offectTop) + "px,0)");
        });

        $('.page-content-foreground').each(function () {
            var elem = $(this);
            var offectTop = nav_height + scroll_top;
            if ($admin_bar.length > 0) {
                offectTop -= nav_height;
            }
            elem.css("clip", "rect(" + offectTop + "px," + window_width + "px," + (doc_height) + "px,0)");
        });

        

        $('.shadow-left-area').each(function () {
            var elem = $(this);
            elem.css('top', nav_height);
            elem.css('width', page_menu_offset.left);
        });

        $('.shadow-right-area').each(function () {
            var elem = $(this);
            elem.css('top', nav_height);
            elem.css('left', page_menu_offset.left + page_menu_outter_width);
        });

        
    };
    $(window).resize(blur_background).scroll(blur_background);
    $(blur_background);


    var hash_smooth_scroll = function () {
        $('a.smooth-scroll').click(function (event) {
            event.preventDefault();
            var href = $.attr(this, 'href');
            var target = $(href);
            if (target.length) {
                $('html,body').animate({
                    scrollTop: target.offset().top
                }, 1000, "swing", function () {
                    window.location.hash = href;
                });
            }
            return false;
        });
    };

    $(hash_smooth_scroll);
    
})(jQuery);